export const BACKGROUND_TRACKING_TIMEOUT_MS = 5 * 60 * 1000;

// NOTE: NSAI-5908 — how long streamed frames may sit in the client-side buffer
// before they are applied to the chat cache while the tab is hidden (a visible
// tab drains on the next animation frame instead). Nobody can see a hidden
// tab, so one cache write per second is plenty; the frames are applied at
// once when the tab comes back.
export const CHAT_STREAM_HIDDEN_FLUSH_MS = 1000;
